import React from "react";

const Dashboard = () => {
      return <></>;
};

export default Dashboard;
